module.exports = __webpack_public_path__ + "static/media/datasheet_listData_row8_picture.6d28e13e.png";